import { useIconStyleSetting, type IconStyle } from '@/components/ui/app-icon';
import { cn } from '@/lib/utils';
import { RadioGroup as RadioGroupPrimitive } from 'radix-ui';

const STYLES: readonly { value: IconStyle; label: string; hint: string }[] = [
  { value: 'candy', label: 'Candy', hint: 'Colourful icons' },
  { value: 'plain', label: 'Plain', hint: 'Simple line icons' },
];

const isStyle = (value: string): value is IconStyle =>
  STYLES.some((style) => style.value === value);

/** Candy or Plain icons, as two labelled radios like the mode switch. */
export function IconStyleSwitch() {
  const { ready, style, setStyle } = useIconStyleSetting();
  return (
    <div className='flex flex-col gap-1.5'>
      <span
        id='icon-style-label'
        className='text-xs font-medium text-muted-foreground'
      >
        Icon style
      </span>
      <RadioGroupPrimitive.Root
        aria-labelledby='icon-style-label'
        value={style}
        disabled={!ready}
        onValueChange={(next) => {
          if (isStyle(next)) setStyle(next);
        }}
        className='grid grid-cols-2 gap-1 rounded-[10px] bg-muted p-1'
      >
        {STYLES.map((option) => (
          <RadioGroupPrimitive.Item
            key={option.value}
            value={option.value}
            title={option.hint}
            className={cn(
              'flex h-8 items-center justify-center rounded-lg text-xs font-semibold text-muted-foreground transition-colors',
              'hover:text-foreground disabled:opacity-60',
              'aria-checked:bg-background aria-checked:text-primary aria-checked:shadow-xs',
              'focus-visible:ring-2 focus-visible:ring-ring focus-visible:outline-hidden'
            )}
          >
            {option.label}
          </RadioGroupPrimitive.Item>
        ))}
      </RadioGroupPrimitive.Root>
    </div>
  );
}
